import { CheckCircleIcon } from "@heroicons/react/24/solid";

const FeatureList = () => {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="font-body text-base font-medium">What&apos;s Included:</h3>
      <ul className="space-y-2">
        {[
          "5-Day Free Trial. Cancel Anytime.",
          "Thousands of delicious, healthy recipes",
          "Build shopping lists easily",
          "Save all your favourite dishes",
        ].map((item, index) => (
          <li
            key={index}
            className="flex items-center gap-x-2 font-body text-base font-medium"
          >
            <CheckCircleIcon className="size-5 text-spring" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FeatureList;
